import React, { Fragment, useState, useEffect, useRef } from "react";
import io from "socket.io-client";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

import { getProfileById } from "../../actions/profile";
import { getDiscussion } from "../../actions/discussion";
import { chatMessage, deleteChatMessage } from "../../actions/stream";
import { getGifs, getGifsSearch } from "../../actions/gif";

import ToggleButton from "../PlayerButtons/ToggleButton";

import DiscussionChat from "../layout/Innovators/DiscussionChat";
import TwoParticipantsVideo from "../layout/Innovators/TwoParticipantsVideo";
import DiscussionInfoOverlay from "../layout/Innovators/DiscussionInfoOverlay";

let socket;

const DiscussionParticipants = ({
  match,
  auth: { user, isAuthenticated, channelid, jobtitle, location, verified },
  profile: { profile },
  getProfileById,
  getGifs,
  getGifsSearch,
  gif: { gifs, loading },
}) => {
  const ENDPOINT = "localhost:5000";

  const [overlay, setoverlay] = useState(false);
  const playerRef = useRef(null);
  const [showChat, setShowChat] = useState(true);
  const [discussions, setDiscussions] = useState([]);
  const [count, setCount] = useState(0);
  const [participantOneCountDown, setParticipantOneCount] = useState(0);
  const [participantTwoCountDown, setParticipantTwoCount] = useState(0);
  const [showGIFs, setshowGIFs] = useState(false);
  const [gifSearch, setGifSearch] = useState(false);
  const [text, setText] = useState("");
  const [foundGif, setGif] = useState("");
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [room, setRoom] = useState(match.params.industryname);
  const [imeBotAvi, setimebotavi] = useState("Innovate_Me_logo_green.png");

  const deleteMessage = (id, message) => {
    deleteChatMessage(match.params.channelid, message);
    const removeIndex = messages
      .map((deletedMessage) => deletedMessage.messageid)
      .indexOf(id);

    messages.splice(removeIndex, 1);

    setMessages([...messages]);
  };

  useEffect(() => {
    getProfileById(match.params.channelid);
    getDiscussion(match.params.channelid);
    getGifs();
  }, [getProfileById, getDiscussion, match.params.channelid, user]);

  useEffect(() => {
    if (user) {
      socket = io(ENDPOINT);

      socket.on("getParticipants", (participants) => {
        setDiscussions([...participants]);
      });

      socket.on("timer", (countDown) => {
        setCount(countDown);
      });

      socket.on("participantOneCount", (participantOneCountDown) => {
        setParticipantOneCount(participantOneCountDown);
      });

      socket.on("participantTwoCount", (participantTwoCountDown) => {
        setParticipantTwoCount(participantTwoCountDown);
      });

      socket.on("roomUsers", (room, users) => {
        console.log(room, users);
      });

      socket.emit("joinRoom", {
        imebotavi: imeBotAvi,
        channelid: user.channelid,
        avatar: user.avatar,
        firstname: user.firstname,
        lastname: user.lastname,
        room: match.params.channelid,
      });
    }

    return () => {
      if (socket) {
        socket.emit("leave");

        socket.on("roomUsers", (users) => {
          // setViewerCount([...users.users]);
        });

        socket.disconnect();

        socket.off();
      }
    };
  }, [ENDPOINT, match.params.channelid, user]);

  useEffect(() => {
    socket.on("message", (message) => {
      setMessages([...messages, message]);
    });
  }, [messages]);

  const sendMessage = (e) => {
    e.preventDefault();
    if (message || foundGif !== "") {
      chatMessage(match.params.channelid, message, foundGif);
      socket.emit(
        "chatMessage",
        message,
        foundGif,
        user.firstname,
        user.lastname,
        user.avatar,
        room
      );
      setMessage("");
      setGif("");
      setshowGIFs(false);
    }
  };

  useEffect(() => {
    socket.on("sendParticipants", (participants) => {
      setDiscussions(participants);
    });
  }, [discussions]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <div
        className={
          showChat ? "flex-only-alt-discussion" : "flex-no-chat-discussion"
        }
      >
        <div className="discussion-layout">
          <div className="video-discussion" ref={playerRef}>
            {overlay && (
              <DiscussionInfoOverlay
                profile={profile}
                setoverlay={setoverlay}
              />
            )}
            <div className="discussion-video-overlay">
              <ToggleButton
                className="Rac__screen-toggle"
                initial={document.fullscreenElement}
                onChange={(active) => {
                  if (!active && KeyboardEvent.key === "Escape") {
                    return document.exitFullscreen();
                  }

                  return playerRef.current.requestFullscreen({
                    navigationUI: "hide",
                  });
                }}
              >
                {(active) => {
                  if (!active) {
                    return (
                      <div className="watch-stream-alt">
                        <button className="watch-stream-button background-green">
                          <i className="fas fa-expand mx-5"></i>
                          Full Screen
                        </button>
                      </div>
                    );
                  }

                  if (active) {
                    return (
                      <div className="watch-stream">
                        <button className="watch-stream-button background-green">
                          <i className="far fa-keyboard mx-5"></i>
                          Esc to Exit
                        </button>
                      </div>
                    );
                  }
                }}
              </ToggleButton>
            </div>
            <TwoParticipantsVideo />
            {!showChat && (
              <div className="showchaticon" onClick={() => setShowChat(true)}>
                <i className="far fa-comment fa-2x green"></i>
              </div>
            )}
          </div>
          <div className="discussion-controls">
            <div class="discussion-icon-alt">
              <div
                class="action-button green"
                onClick={() => {
                  if (overlay) {
                    setoverlay(false);
                  } else {
                    setoverlay(true);
                  }
                }}
              >
                <i class="fas fa-info action-icon fa-lg"></i>
              </div>
              <p class="action-text">Discussion Info</p>
            </div>
            <div class="discussion-icon-alt">
              <div class="action-button green">
                <i class="fas fa-volume-mute action-icon fa-lg"></i>
              </div>
              <p class="action-text">Muted</p>
            </div>
            <div class="discussion-icon-alt">
              <div class="action-button green">
                <i class="fas fa-video-slash action-icon-video-off fa-lg"></i>
              </div>
              <p class="action-text">Camera Off</p>
            </div>
            <div class="discussion-icon-alt">
              <div class="action-button green">
                <i class="fas fa-user action-icon fa-lg"></i>
              </div>
              <p class="action-text">17,291</p>
            </div>
            <div class="discussion-icon-alt">
              <div class="action-button white">
                <i class="fas fa-flag action-icon fa-lg"></i>
              </div>
              <p class="action-text">Leave Discussion</p>
            </div>
          </div>
        </div>
        {showChat && (
          <DiscussionChat
            messages={messages}
            message={message}
            setMessage={setMessage}
            deleteMessage={deleteMessage}
            gifs={gifs}
            setGif={setGif}
            foundGif={foundGif}
            showGIFs={showGIFs}
            setshowGIFs={setshowGIFs}
            getGifsSearch={getGifsSearch}
            gifSearch={gifSearch}
            setGifSearch={setGifSearch}
            sendMessage={sendMessage}
            text={text}
            setText={setText}
            setShowChat={setShowChat}
          />
        )}
      </div>
    </Fragment>
  );
};

DiscussionParticipants.propTypes = {
  profile: PropTypes.object.isRequired,
  getGifs: PropTypes.func.isRequired,
  getProfileById: PropTypes.func.isRequired,
  getDiscussion: PropTypes.func.isRequired,
  chatMessage: PropTypes.func.isRequired,
  deleteChatMessage: PropTypes.func.isRequired,
  getGifsSearch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
  gif: state.gif,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getProfileById,
  getDiscussion,
  chatMessage,
  deleteChatMessage,
  getGifs,
  getGifsSearch,
})(DiscussionParticipants);
